import { Component } from "@angular/core";
import { Store } from "@ngrx/store";
import { AppState } from "src/app/ngrx/reducers";
import { NotificationSelectors } from "src/app/ngrx/selectors";

@Component({
  selector: "app-notifications",
  imports: [],
  templateUrl: "./notifications.component.html",
  styles: ``,
})
export class NotificationsComponent {
  activeNotifications = this.store.selectSignal(
    NotificationSelectors.activeNotifications,
  );

  constructor(private readonly store: Store<AppState>) {}
}
